import { ReactElement } from 'react';
import styles from './ellipsisContentColumn.module.scss';

export const EllipsisContentColumn: React.FC<{
  content: string | ReactElement;
  lineClamp: number;
}> = ({ content, lineClamp }) => {
  return (
    <div className={styles.content} style={{ WebkitLineClamp: lineClamp }}>
      {content}
    </div>
  );
};
